export default "__VITE_PUBLIC_ASSET__9063bc5d__"